<div class="row row-eq-height d-flex h100" *ngFor="let row of contentRows">
    <app-content-block [content]="content"
        *ngFor="let content of row"
        [ngClass]="{ 'col-md-12': row.length === 1,
                     'col-md-6': row.length === 2,
                     'col-md-4': row.length === 3 }" >
    </app-content-block>
</div>
